import React from 'react';
import Typography from '@material-ui/core/Typography';
import { experimentalStyled } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import styled from '@emotion/styled';
import img from '../../static/images/onboard_no_shifts.png.js';
var Frame = experimentalStyled(Box)(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.spacing(0),
    border: '1px solid #E6E6E6',
    borderRadius: 3
  };
});
var ContentFrame = experimentalStyled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    padding: theme.spacing(1),
    borderBottom: '1px solid #E6E6E6'
  };
});
var ListWrapper = styled.div(function (_ref3) {
  var theme = _ref3.theme;
  return "\n  ".concat(theme.breakpoints.down('md'), " {\n    max-height: 550px;\n    overflow: auto;\n  }\n");
});

var ListingBox = function ListingBox(_ref4) {
  var Title = _ref4.Title,
      List = _ref4.List;
  return /*#__PURE__*/React.createElement(Frame, null, /*#__PURE__*/React.createElement(ContentFrame, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    sx: {
      textTransform: 'capitalize'
    }
  }, Title)), /*#__PURE__*/React.createElement(ListWrapper, null, List && List.length > 0 && List.map(function (item) {
    return /*#__PURE__*/React.createElement(ContentFrame, null, item);
  }), !List.length && /*#__PURE__*/React.createElement(ContentFrame, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "no shifts",
    src: img,
    width: "40%"
  }), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      textTransform: 'capitalize'
    },
    align: "center",
    component: "span"
  }, "It appears you have no", ' ', Title, "."))));
};

export { ListingBox };